import { render, staticRenderFns } from "./alegaciones_respuesta_token.vue?vue&type=template&id=11d0a28c&scoped=true&"
import script from "./alegaciones_respuesta_token.vue?vue&type=script&lang=ts&"
export * from "./alegaciones_respuesta_token.vue?vue&type=script&lang=ts&"
import style0 from "./alegaciones_respuesta_token.vue?vue&type=style&index=0&id=11d0a28c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d0a28c",
  null
  
)

export default component.exports